import styled, { createGlobalStyle } from "styled-components";

export const DeleteProjectModalStyle = createGlobalStyle`
  .delete-project {
    display: flex;
    flex-direction: column;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
  }
`;

export const DeleteProjectWrapper = styled.div`
  p {
    margin-top: 12px;
    margin-bottom: unset;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
  }
`;
